module.exports = __webpack_public_path__ + "static/media/step-2.c45d1001.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BuyForMe/icons/step-2.svg
 ** module id = 876
 ** module chunks = 0
 **/